import { Controller } from "@hotwired/stimulus";

export default class InventoryCalendarController extends Controller {
  static targets = ["yearContent", "monthTabs", "yearTabs"];

  static LOW_AVAILABILITY_THRESHOLD = 3;

  connect() {
    // Read data from the script tag instead of data attributes
    const dataScript = this.element.querySelector(
      "[data-inventory-calendar-data]"
    );
    if (dataScript) {
      const data = JSON.parse(dataScript.textContent);
      this.currentYear = data.currentYear;
      this.dateRanges = data.dateRanges;
      this.availabilities = data.availabilities;

      this.showYearData(this.currentYear);
    }
  }

  showYear(event) {
    const year = parseInt(event.currentTarget.dataset.year, 10);
    this.showYearData(year);
  }

  showYearData(year) {
    let dateRange = null;
    if (year === this.currentYear - 1) {
      dateRange = this.dateRanges.prev;
    } else if (year === this.currentYear) {
      dateRange = this.dateRanges.current;
    } else {
      dateRange = this.dateRanges.next;
    }

    this.yearContentTarget.innerHTML = "";
    this.monthTabsTarget.innerHTML = "";

    const groupedDates =
      InventoryCalendarController.groupDatesByMonth(dateRange);
    this.createMonthTabs(groupedDates);
    this.displayMonthData(
      groupedDates[new Date().getMonth() + 1] ||
        groupedDates[Object.keys(groupedDates)[0]]
    );
    this.highlightSelectedYear(year);
  }

  static groupDatesByMonth(dates) {
    return dates.reduce((acc, date) => {
      const month = new Date(date).getMonth() + 1;
      if (!acc[month]) acc[month] = [];
      acc[month].push(date);
      return acc;
    }, {});
  }

  createMonthTabs(groupedDates) {
    const currentMonth = new Date().getMonth() + 1;

    Object.keys(groupedDates).forEach((month) => {
      const monthTab = document.createElement("a");
      monthTab.className =
        "bg-white inline-block w-14 py-2 px-4 text-blue-500 font-semibold hover:text-blue-800 cursor-pointer";
      monthTab.innerText = new Date(groupedDates[month][0]).toLocaleString(
        "en-us",
        { month: "short" }
      );
      monthTab.dataset.action = "click->inventory-calendar#showMonth";
      monthTab.dataset.dates = JSON.stringify(groupedDates[month]);

      this.monthTabsTarget.appendChild(monthTab);

      if (parseInt(month, 10) === currentMonth) {
        monthTab.classList.add("selected-tab");
      }
    });
  }

  highlightSelectedYear(year) {
    this.yearTabsTarget.querySelectorAll("a").forEach((tab) => {
      tab.classList.remove("selected-year");
    });
    const selectedYearTab = this.yearTabsTarget.querySelector(`#year-${year}`);
    if (selectedYearTab) {
      selectedYearTab.classList.add("selected-year");
    }
  }

  showMonth(event) {
    const dates = JSON.parse(event.currentTarget.dataset.dates);

    this.monthTabsTarget.querySelectorAll("a").forEach((tab) => {
      tab.classList.remove("selected-tab");
    });
    event.currentTarget.classList.add("selected-tab");

    this.displayMonthData(dates);
  }

  displayMonthData(dates) {
    this.yearContentTarget.innerHTML = "";
    const flexContainer = document.createElement("div");
    flexContainer.className = "flex overflow-x-auto";

    dates.forEach((date) => {
      const dayCell = document.createElement("div");
      dayCell.className =
        "day-cell bg-white-100 text-green-600 py-1 rounded w-16 text-center mx-1";

      const dayOfWeekDiv = document.createElement("div");
      dayOfWeekDiv.className = "text-black";
      dayOfWeekDiv.innerText = new Date(date).toLocaleString("en-us", {
        weekday: "short",
      });
      dayCell.appendChild(dayOfWeekDiv);

      const dayDiv = document.createElement("div");
      dayDiv.className = "text-black";
      dayDiv.innerText = new Date(date).getDate();
      dayCell.appendChild(dayDiv);

      const quantity = this.availabilities[date] || 0;
      const quantityDiv = document.createElement("div");
      const quantityDivB = document.createElement("b");
      let bgClass;
      if (quantity === 0) {
        bgClass = "bg-cal-red";
      } else if (
        quantity > 0 &&
        quantity < this.constructor.LOW_AVAILABILITY_THRESHOLD
      ) {
        bgClass = "bg-cal-light-yellow txt-cal-yellow";
      } else {
        bgClass = "bg-cal-green";
      }

      quantityDiv.className = `quantity-indicator ${bgClass} text-white py-1 squared-full w-8 mx-auto`;
      quantityDiv.appendChild(quantityDivB);
      quantityDivB.innerText = quantity;
      dayCell.appendChild(quantityDiv);

      flexContainer.appendChild(dayCell);
    });

    this.yearContentTarget.appendChild(flexContainer);
  }
}
